<template>
  <v-dialog v-model="dialog" persistent max-width="350" class="overlay">
    <template v-slot:activator="{on: dialog}" v-if="mode === ComponentMode.CREATE">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{...tooltip, ...dialog}">
            <v-icon>{{ mdiStar }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.map.userFeedbackForm.rateTravel') }}</span>
      </v-tooltip>
    </template>
    <template v-slot:activator="{ on }" v-else-if="mode === ComponentMode.EDIT">
      <v-btn icon v-on="on">
        <v-icon>{{ mdiSquareEditOutline }}</v-icon>
      </v-btn>
    </template>
    <v-card outlined>
      <v-card-title class="headline" primary-title>{{ $vuetify.lang.t('$vuetify.map.userFeedbackForm.travelRating') }}
        <v-spacer></v-spacer>
        <v-icon small v-ripple @click="dialog = false">{{ mdiClose }}</v-icon>
      </v-card-title>

      <v-card-text>
        <v-list>

          <v-subheader>{{ $vuetify.lang.t('$vuetify.map.userFeedbackForm.drowsinessRating') }}</v-subheader>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-center">
                <v-rating dense hover v-model="drowsinessRating" color="amber" length="9"></v-rating>
              </v-list-item-title>
              <v-list-item-subtitle class="text-center">
                <span class="caption font-weight-light font-italic font-no-wrap">{{ $vuetify.lang.t(`$vuetify.map.drowsinessCaption.${[drowsinessRating - 1]}`) }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-subheader class="aggressivenessHeader">{{
              $vuetify.lang.t('$vuetify.map.userFeedbackForm.drivingStyle.title') }}
            </v-subheader>
            <v-switch v-model="aggressivenessValue" :label="aggressivenessLabel"></v-switch>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn :disabled="blocked" text color="green" class="mx-2" @click="sendState">{{
          $vuetify.lang.t('$vuetify.shared.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { MAP_PAGE } from '../../../store/modules'
import { SEND_USER_FEEDBACK } from '../../../store/actions'
import { ComponentMode, UserFeedbackDangerousState } from '../../../enum'
import { mdiClose, mdiSquareEditOutline, mdiStar } from '@mdi/js'
import travelSelectionMixin from '../../../mixins/travelSelectionMixin'
import backend from '../../../backend'

const { mapActions } = createNamespacedHelpers(MAP_PAGE)

// TODO: refactor this component - remove API calling from store/map.js and call it here, and pass result after in case of using different types of usage

export default {
  name: 'userFeedbackForm',
  props: {
    mode: {
      type: String,
      default: ComponentMode.CREATE
    },
    // check which type is using in this component
    type: {
      type: String,
      default: 'vuex'
    },
    drowsiness: {
      type: Number,
      default: 5
    },
    aggressiveness: {
      type: Boolean,
      default: false
    },
    // pass trip_datetimestart and userid in case of type !== 'vuex'
    travelDatetimestart: {
      type: Number,
      default: null
    },
    userId: {
      type: Number,
      default: null
    }
  },
  mixins: [travelSelectionMixin],
  data () {
    return {
      dialog: false,
      blocked: false,
      drowsinessRating: this.drowsiness,
      aggressivenessValue: this.aggressiveness,

      mdiClose: mdiClose,
      mdiSquareEditOutline: mdiSquareEditOutline,
      mdiStar: mdiStar
    }
  },
  computed: {
    aggressivenessLabel () {
      return this.$vuetify.lang.t(`$vuetify.map.userFeedbackForm.drivingStyle.${this.aggressivenessValue ? 'aggressive' : 'calm'}`)
    }
  },
  methods: {
    // TODO: move this function from 'map' module
    ...mapActions([SEND_USER_FEEDBACK]),
    async sendState () {
      this.blocked = true

      if (this.type === 'vuex') {
        await this[SEND_USER_FEEDBACK]({
          feedback: [{
            dangerous_state: UserFeedbackDangerousState.DROWSINESS,
            feedback: this.drowsinessRating
          }, {
            dangerous_state: UserFeedbackDangerousState.AGGRESSIVENESS,
            feedback: this.aggressivenessValue ? 1 : 0
          }],
          trip_datetimestart: this.travelSelection.travel.datetimestart.getTime(),
          userid: this.travelSelection.travel.user.userId
        })
      } else {
        // call api if possible
        if (this.travelDatetimestart && this.userId) {
          try {
            const feedback = [{
              dangerous_state: UserFeedbackDangerousState.DROWSINESS,
              feedback: this.drowsinessRating
            }, {
              dangerous_state: UserFeedbackDangerousState.AGGRESSIVENESS,
              feedback: this.aggressivenessValue ? 1 : 0
            }]

            const response = await backend.sendUserFeedback({
              feedback,
              trip_datetimestart: this.travelDatetimestart,
              userid: this.userId
            })

            if (response.data.success) {
              this.$emit('feedback-processed', feedback)
            } else {
              console.error(response.data)
            }
          } catch (e) {
            console.error(e)
          }
        }
      }

      this.blocked = false
      this.dialog = false
    }
  },
  created () {
    // js code now will recognize enum in templates
    this['ComponentMode'] = ComponentMode
  }
}
</script>

<style scoped>
  .overlay {
    z-index: 1000;
  }

  .mobile-button {
    margin: 0 0 0 -350px;
  }

  .font-no-wrap {
    white-space: normal;
  }

  .aggressivenessHeader {
    padding-left: 0;
  }

  .v-dialog > .v-card > .v-card__text {
    padding-bottom: 0;
  }
</style>
